import React from "react"

import InnerHTML from "dangerously-set-html-content"
import { IBasicHtml } from "../../../interfaces"

class CmsHtml extends React.Component<IBasicHtml> {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="cms-html">
        <InnerHTML html={this.props.html} />
      </div>
    )
  }
}

export default CmsHtml
